"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeWord = exports.mapLanguage = exports.isTranscriptTheSame = exports.getWords = exports.adjustTimings = void 0;
var _diff = require("diff");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getWords = exports.getWords = function getWords(string) {
  var regex = new RegExp('([^\\s>]+(?![^<]*>))', 'ig');
  var result = string.replace(/&nbsp;/gi, ' ').match(regex);
  return result || [];
};
var normalizeWord = exports.normalizeWord = function normalizeWord(word) {
  return word.toLowerCase().replace(/\W/g, '');
};
var isTranscriptTheSame = exports.isTranscriptTheSame = function isTranscriptTheSame(transcriptA, transcriptB) {
  var normalizedA = transcriptA.toLowerCase().replace(/\W/g, ' ').replace(/\s+/g, ' ').trim();
  var normalizedB = transcriptB.toLowerCase().replace(/\W/g, ' ').replace(/\s+/g, ' ').trim();
  return normalizedA === normalizedB;
};
var adjustTimings = exports.adjustTimings = function adjustTimings(content, timings) {
  var gap = 10; // gap between words in ms
  var duration = 90; // default word duration in ms

  var words = getWords(content);

  // Convert start/end to number
  timings = timings.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      start: +item.start,
      end: +item.end
    });
  });
  var result;
  if (words.length === timings.length) {
    return timings.map(function (item, index) {
      return _objectSpread(_objectSpread({}, item), {}, {
        word: words[index]
      });
    });
  }
  var idealTimings = words.map(function (word) {
    return {
      word: word,
      start: -1,
      end: -1
    };
  });
  var diff = (0, _diff.diffArrays)(idealTimings, timings, {
    comparator: function comparator(a, b) {
      return normalizeWord(a.word) === normalizeWord(b.word);
    }
  });
  result = diff.reduce(function (array, el) {
    if (el.added) {
      return array;
    }
    return [].concat(_toConsumableArray(array), _toConsumableArray(el.value));
  }, []);

  // Calculate missing start/end points
  for (var i = 0; i < result.length; i++) {
    var item = result[i];
    if (item.start === -1) {
      var prev = result[i - 1];
      var next = result[i + 1];
      item.start = prev ? prev.end + gap : 0;
      item.end = next && next.start !== -1 ? next.start - gap : item.start + duration;
    }
  }
  result = result.map(function (item, index) {
    return _objectSpread(_objectSpread({}, item), {}, {
      word: words[index]
    });
  });
  return result;
};
var mapLanguage = exports.mapLanguage = function mapLanguage(language) {
  var mapper = {
    en: 'en-us'
  };
  if (language in mapper) {
    return mapper[language];
  }
  return language;
};